import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login/Login.vue';
import Logout from './views/Logout/Logout.vue';
import Dashboard from './views/Dashboard/Dashboard.vue';
import PerfilTruck from './views/Company/PerfilTruck/Perfil.vue';
import PerfilTruckTrailer from './views/Company/PerfilTruckTrailer/Perfil.vue';
import PerfilTruckService from './views/Company/PerfilTruckService/Perfil.vue';
import PerfilCertified from './views/Company/PerfilCertified/Perfil.vue';
import WorkHours from './views/Company/WorkHours/WorkHours.vue';
import CompanyRegistration from './views/Company/CompanyRegistration.vue';
import CrudCompany from './views/Company/Crud/Company.vue';
import User from './views/User/User.vue';
import Company from './views/Company/Company.vue';
import CrudUser from './views/User/Crud/User.vue';
import ChangeEmail from './views/User/ChangeEmail/ChangeEmail.vue';
import ChangePassword from './views/User/ChangePassword/ChangePassword.vue';
import ListUser from './views/User/List/User.vue';
import paymentMethod from './views/Company/PaymentMethods/PaymentMethods.vue';
import Terms from './views/Terms/Terms.vue';
import VueSession from 'vue-session';//https://github.com/victorsferreira/vue-session
import PrivacyData from './views/PrivacyData/PrivacyData.vue';
import BankSlips from './views/Company/BankSlips/BankSlips.vue';
Vue.use(VueSession)
Vue.use(Router)

const session = Vue.prototype.$session;


const checkSession = () => {
  let user = session.get('user');
  let isUser = session.exists('user');
  let isToken = session.exists('token');


  if (!isUser || !isToken){
    session.destroy();
    return '/';//redirect to login page
  }else{
    let href = window.location.href
    if (user.companyUser.subtype != 'ADMIN_MASTER' && href.indexOf('/payment-method')==-1 && href.indexOf('/dashboard')==-1) {
      let rout = checkInfos();
      if (rout){
        window.location.href = "?#/"+rout;
        return rout;
      }
      
    }

    return;
  }
}

const checkInfos = () => {
  let user = session.get('user');
  if (user.companyUser && user.companyUser.company){
    if (!user.isAcceptGeneralTerms || !user.isAcceptPurchaseTerms ){
      return  '/dashboard';
    }
  }
  return;
}

function checkCard(){
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/users',
      name: 'users',
      component: User
    },
    {
      path: '/companies',
      name: 'companies',
      component: Company
    },
    {
      path: '/crud-companies',
      name: 'crud-companies',
      component: CrudCompany,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/perfil-trucks',
      name: 'perfil-trucks',
      component: PerfilTruck,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/perfil-trucks-trailer',
      name: 'perfil-trucks-trailer',
      component: PerfilTruckTrailer,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/perfil-trucks-service',
      name: 'perfil-trucks-service',
      component: PerfilTruckService,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/perfil-certifies',
      name: 'perfil-certifies',
      component: PerfilCertified,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/work-hours',
      name: 'work-hours',
      component: WorkHours,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/crud-user',
      name: 'crud-user',
      component: CrudUser,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/change-email',
      name: 'change-email',
      component: ChangeEmail,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/list-user',
      name: 'list-user',
      component: ListUser,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/company-registration',
      name: 'company-registration',
      component: CompanyRegistration,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/payment-method',
      name: 'payment-method',
      component: paymentMethod,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/bank-slips',
      name: 'bank-slips',
      component: BankSlips,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
  {
    path: '/privacydata',
    name: 'privacydata',
    component: PrivacyData,
    beforeEnter: (to, from, next) => {
       next(checkSession());
     }
  },
  ]
});